import {Component, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {Dac6ReporterApiService} from '../../services/dac6-reporter.service';
import {Router} from '@angular/router';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {CommandService} from '@core/services/command.service';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {HallmarkTaggingService} from '@core/services/hallmark-tagging.service';
import {ResetHallmarkKeywordCommand, SaveHallmarkKeywordCommand} from '../../commands/dac6-reporter.command';

@Component({
    standalone: false,
    selector: 'particle-hallmark-tag-suggestion-dialog',
  templateUrl: './hallmark-tag-suggestion-dialog.component.html',
  styleUrls: ['./hallmark-tag-suggestion-dialog.component.scss']
})
export class HallmarkTagSuggestionDialogComponent implements OnInit, IDialogView {

  inputForm: any;
  hallmarkInfo: any[];
  hallmarkInfoKeysForFilter: any[];
  filteredOptions$: Observable<string[]>;
  data: DialogModel;
  constructor(private formBuilder: FormBuilder,
              private dac6RepoterApiService: Dac6ReporterApiService,
              private router: Router,
              private dialogService: DialogService,
              private commandService: CommandService,
              private hallmarkTaggingService: HallmarkTaggingService) {
    this.inputForm = this.formBuilder.group({
      value: ['']
    });
    this.hallmarkInfoKeysForFilter = [];
  }

  ngOnInit(): void {
    this.getAllHallmarkAutoTags();
  }


  private getAllHallmarkAutoTags() {
    this.dac6RepoterApiService.getAllHallmarkAutoTags().subscribe(res => {
      this.updateFilterData(res);
      this.hallmarkInfo = res;
      this.hallmarkInfo = this.hallmarkInfo.map(h => {
        h.keywords = h.keywords.map(k => k.toLowerCase());
        h.selectedTags = h.selectedTags.map(k => k.toLowerCase());
        return h;
      });
      this.search();
    });
  }

  private updateFilterData(res) {
    let keyWords = [];
    res.forEach(t => t.keywords.forEach(k => keyWords.push(k)));
    res.forEach(t => t.selectedTags.forEach(k => keyWords.push(k)));
    const unique = (value, index, self) => {
      return self.indexOf(value) === index;
    };
    keyWords = keyWords.filter(unique);
    const newKeyWords = [];
    keyWords.forEach(k => {
      if (k.replace(/\s/g, '').length) { newKeyWords.push(k); }
    });
    this.hallmarkInfoKeysForFilter = newKeyWords;
    this.filteredOptions$ = this.inputForm.get('value').valueChanges
      .pipe(
        startWith(this.inputForm.controls['value'].value.toLowerCase()),
        map(value => {
          if (typeof value === 'string') {
            return this._filter(value);
          }
        })
      );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    const keyWords = [];
    if (this.hallmarkInfoKeysForFilter == null) { return keyWords; }
    this.hallmarkInfoKeysForFilter.forEach(k => {
      if (k.toLowerCase().includes(filterValue)) { keyWords.push(k); }
    });
    return keyWords;
  }

  search() {
    const keyTerm = this.inputForm.controls['value'].value.toLowerCase();
    this.hallmarkInfo.map(hallmark => {
      hallmark.isChecked = (hallmark.keywords.includes(keyTerm) || hallmark.selectedTags.includes(keyTerm));
      return hallmark;
    });
  }

  navigateToHallmark(hallmark: any) {
    console.log('this::::', this);
    this.dialogService.closeDialog(
      {action: 'nevigateToHallmark', category: hallmark.category, key: hallmark.key}
    );
  }


  openHallmarkTaggingDialog(hallmark: any) {
    this.dac6RepoterApiService.getHallmarkAutoTags(hallmark.hallmarkId).subscribe(hallmarkInfo => {
      const dialogueModel = DialogModel.create(hallmarkInfo.taggingTitle,
        'HallmarkTaggingDialogComponent',
        {hallmarkInfo: hallmarkInfo}, '900px', '900px');
      dialogueModel.okCaption = 'Save';
      dialogueModel.otherButtonCaption = 'Reset to Defaults';
      this.dialogService.showOkCancelDialog(dialogueModel).subscribe(res => {
        if (res.action === 'OK') {
          this.saveHallMarkKeyword(res.data.input.hallmarkInfo.id, res.data.input.hallmarkInfo.selectedTags);
        }
      });
    });
  }
  private saveHallMarkKeyword(id: any, selectedTags: string[]) {
    const command = new SaveHallmarkKeywordCommand(id, {'SelectedTags': selectedTags});
    this.commandService.executeCommand(command).subscribe(state => {
      if (state.Payload === 'Item Save Successful') {
        this.getAllHallmarkAutoTags();
      }
    });
  }

  onOkClicked(): boolean {
    return true;
  }
}
